import FlowConditionsConfig from './FlowConditionsConfig'

export default FlowConditionsConfig
